// eslint-disable-next-line import/prefer-default-export
export const GET_VOLTAGES = 'GET_VOLTAGES';
export const GET_LOW_VOLTAGES = 'GET_LOW_VOLTAGES';
